import { createAction } from 'redux-actions';
import createUploadFileToS3Epic from '../epics/uploadFileToS3Util';

export const UPLOAD_FILE_TO_S3_ACTION_NAME = 'UPLOAD_FILE_TO_S3_ACTION';
export const uploadFileToS3Action = createAction(UPLOAD_FILE_TO_S3_ACTION_NAME);

export const uploadFileToS3Epic = createUploadFileToS3Epic({
  actionType: UPLOAD_FILE_TO_S3_ACTION_NAME,
});
